module.exports = __webpack_public_path__ + "static/media/FrontRight.02e957c5.jpg";